import { FC } from 'react'

import styled from 'styled-components'

import { ScheduleSteps } from 'src/Components/PrimaryScheduleTabs'
import { useAppSelector } from 'src/Hooks/redux'
import { useCheckoutEvents } from 'src/Hooks/useCheckoutEvents'
import { useCustomSearchParams } from 'src/Hooks/useCustomSearchParams'
import {
  getIsTiktokAudienceLoading,
  getTiktokPrice,
} from 'src/Redux/schedule-process/audienceTiktokSlice/selectors'
import {
  getScheduledTikTokCampaign,
  getScheduledTikTokCampaignComment,
} from 'src/Redux/schedule-process/tiktokCampaign/selectors'
import { CampaignPlatformTypeEnum } from 'src/Types/campaigns'
import { CTAButton } from 'src/Components/Buttons/CTAButton'
import { useReels } from 'src/Hooks/useReels'
import { MAX_MOBILE_WIDTH } from 'src/Styled/variables'

const StyledCTAButton = styled(CTAButton)`
  padding: 0 40px;
  width: fit-content;

  @media screen and (max-width: ${MAX_MOBILE_WIDTH}) {
    width: 100%;
  }
`
const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;

  @media screen and (max-width: ${MAX_MOBILE_WIDTH}) {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    gap: 0;
  }
`

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;

  @media screen and (max-width: ${MAX_MOBILE_WIDTH}) {
    padding: 8px 16px;
    background: ${({ theme }) => theme.color.white};
    border-top: 1px solid ${({ theme }) => theme.color.lightGrey};
  }
`

const Text = styled.div`
  color: ${({ theme }) => theme.color.darkGrey};
  text-align: center;
  font-family: 'Segoe UI';
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
`

export const TiktokScheduleContinueButton: FC = () => {
  const { handleCheckoutStartEvent } = useCheckoutEvents()
  const { isReelsCampaign } = useReels()
  const { setSearch } = useCustomSearchParams()
  const scheduledCampaign = useAppSelector(getScheduledTikTokCampaign)
  const price = useAppSelector(getTiktokPrice)
  const isUpdateCampaignLoading = useAppSelector(getIsTiktokAudienceLoading)
  const comment = useAppSelector(getScheduledTikTokCampaignComment)

  const isContinueButtonDisabled = isUpdateCampaignLoading || !comment

  const handleClick = (): void => {
    const query = {
      step: ScheduleSteps.CHECKOUT,
    }
    setSearch(query)

    handleCheckoutStartEvent({
      platformName: isReelsCampaign
        ? CampaignPlatformTypeEnum.REELS
        : CampaignPlatformTypeEnum.TIKTOK,
      id: Number(scheduledCampaign.id),
      campaignType: scheduledCampaign.type,
      startDate: scheduledCampaign?.startDate?.toString() ?? '',
      resultPrice: price,
      genres: [],
      languages: [],
    })
  }

  if (!price) {
    return null
  }

  return (
    <Container>
      <ButtonWrapper>
        <StyledCTAButton
          onClick={handleClick}
          disabled={isContinueButtonDisabled}
        >
          Continue
        </StyledCTAButton>
        <Text>You won`t be charged yet</Text>
      </ButtonWrapper>
    </Container>
  )
}
